import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Accordion from '@material-ui/core/ExpansionPanel';
import AccordionSummary from '@material-ui/core/ExpansionPanelSummary';
import AccordionDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { DynamicForm } from '../common/components/DynamicForm';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { creativeTagsFieldDef } from '../data/data';
import { AppConfig } from '../AppConfig';

const CREATIVE_TAG_KEYS = [
  'POLITICAL_SEVERE',
  'POLITICAL_ISSUE',
  'ADULT',
  'VIOLENCE',
  'DRUGS',
  'WEAPONS',
  'GAMBLING_KIDS',
  'ALCOHOL',
  'NICOTINE',
  'GAMBLING',
  'RELIGION',
  'SUGGESTIVE',
  'DEROGATORY'
];

export class CreativeTagsSelector extends Component {
  constructor(props) {
    super(props);
    this.creativeTagOptions = this.getCreativeTagOptions(props.current, props.tagOptions);
    if (this.creativeTagOptions.length > 0) {
      this.formDefinition = this.buildFormDefinition(props, this.creativeTagOptions);
    }
  }

  buildFormDefinition(props, creativeTagOptions) {
    const formDefinition = JSON.parse(JSON.stringify(creativeTagsFieldDef.fieldDef));
    const tagsField = formDefinition.steps[0].fields.find((field) => field.key === 'tags');

    tagsField.options = creativeTagOptions;
    tagsField.value = ((props.current && props.current.validatedTags) || [])
      .filter((tag) => creativeTagOptions.find((option) => option.key === tag));

    return formDefinition;
  }

  getCreativeTagOptions(current, tagOptions) {
    const attachedTags = (current && current.tags) || [];
    return attachedTags
      .filter((tagKey) => CREATIVE_TAG_KEYS.indexOf(tagKey) > -1)
      .map((tagKey) => {
        const option = (tagOptions || []).find((current) => current.key === tagKey);

        return option || { key: tagKey, text: tagKey };
      });
  }

  onFormSubmit = (data, callback) => {
    const { current, orgId, onSaved } = this.props;
    const dynamicFormInstance = data.caller;

    if (!current) {
      callback();
      return;
    }
    const updatedTags = (data.formData.tags || []).filter((tag) => this.creativeTagOptions.find((option) => option.key === tag))

    ApiHelper.call(
      {
        method: 'PUT',
        paths: ['miscs', 'creatives'],
        jsonBody: {
          orgId,
          creativeId: current.id,
          validatedTags: updatedTags,
          updateAction: 'tagValidation'
        }
      },
      (err) => {
        if (err) {
          dynamicFormInstance.setState({
            success: false,
            message: Helper.getErrorMsg(err),
            inProcess: false
          });
          return;
        }
        // dynamicFormInstance.setState({
        //   success: true,
        //   message: Helper.getString('successful'),
        //   inProcess: false
        // });
        if (onSaved) onSaved(updatedTags);
        callback();
      }
    );
  }

  renderDescriptionAccordion() {
    if (!this.props.current || !this.props.current.descr) {
      return null;
    }

    return (
      <Accordion
        elevation={0}
        className={css(Styles.descriptionAccordion)}
        classes={{ expanded: css(Styles.descriptionAccordionExpanded) }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={css(Styles.descriptionSummary)}
          classes={{
            content: css(Styles.descriptionSummaryContent),
            expanded: css(Styles.descriptionSummaryExpanded)
          }}
        >
          <Typography className={css(Styles.descriptionTitle)}>Creative Description</Typography>
        </AccordionSummary>
        <AccordionDetails className={css(Styles.descriptionDetails)}>
          <div className={css(Styles.descrText, Styles.noMarginBottom)}>
            {this.props.current.descr}
          </div>
        </AccordionDetails>
      </Accordion>
    );
  }

  render() {
    if (this.creativeTagOptions.length === 0) {
      return this.renderDescriptionAccordion();
    }

    return (
      <div className={css(Styles.container)}>
        {this.props.current && this.props.current.tags && this.props.current.tags && this.props.current.tags.length > 0 &&
          <div className={css(Styles.tagContaner)}>
            <span style={{ color: AppConfig.TINT_COLOUR }}>Review the tags identified by AI and select the ones that correctly apply to this creative.</span>
            {/* <div className={css(Styles.tagHolder)}>
              {this.props.current.tags.map((tag, index) => (
                <span key={`tag_${index}`} className={css(Styles.tagChip)}>
                  {tag}
                </span>
              ))}
            </div> */}
          </div>
        }
        {this.renderDescriptionAccordion()}
        <DynamicForm
          formDefinition={this.formDefinition}
          apiData={{ orgId: this.props.orgId, id: this.props.current && this.props.current.id }}
          customSubmit={this.onFormSubmit}
        />
      </div>
    );
  }
}


const Styles = StyleSheet.create({
  container: {
    width: '100%',
    marginTop: 16
  },
  tagChip: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 10px',
    borderRadius: 999,
    backgroundColor: '#F3F4F6',
    color: '#222222',
    fontSize: 12,
    lineHeight: 1.2
  },
  tagHolder: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    margin: '6px 0'
  },
  tagContaner: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginBottom: 10
  },
  descriptionAccordion: {
    boxShadow: 'none',
    marginTop: 10,
    marginBottom: 10,
    ':before': {
      display: 'none'
    }
  },
  descriptionAccordionExpanded: {
    marginTop: '10px !important',
    marginBottom: '10px !important'
  },
  descriptionSummary: {
    backgroundColor: '#F5F5F5',
    minHeight: 36,
    borderRadius: 8
  },
  descriptionSummaryContent: {
    marginTop: '0 !important',
    marginBottom: '0 !important'
  },
  descriptionSummaryExpanded: {
    minHeight: 'unset !important'
  },
  descriptionTitle: {
    color: '#222222',
    fontSize: 14,
    fontWeight: 600
  },
  descriptionDetails: {
    display: 'block',
    padding: 12
  },
  descrText: {
    marginTop: 15,
    marginBottom: 15
  },
  noMarginBottom: {
    marginBottom: 0
  }
});


// WEBPACK FOOTER //
// ./src/components/CreativeTagsSelector.js